import { useState } from "react"

export const useSearchValue = () => {
  const [value, setValue] = useState("")
  const [query, setQuery] = useState("")
  const performSearch = () => {
    setQuery(value)
  }

  const cancelSearch = () => {
    setValue("")
    setQuery("")
  }

  return {
    performSearch,
    cancelSearch,
    value,
    setValue,
    query,
  }
}
